<template>
  <div class="gallery">
    <div class="glide__track" data-glide-el="track">
      <ul class="glide__slides">
        <li v-for="(image, index) in images"
            :key="index"
            :ref="image.publicId"
            class="glide__slide">
          <img :alt="`Loan image ${index}`" :src="$get(image, 'medium', null)">
        </li>
      </ul>
      <div v-show="!renderThumbs" class="glide__bullets" data-glide-el="controls[nav]">
        <button v-for="(image, index) in images"
                class="glide__bullet"
                :data-glide-dir="`=${index}`" />
      </div>
      <div v-show="renderThumbs" class="glide__thumbs" data-glide-el="controls[nav]">
        <a v-for="(image, index) in images"
           href="#"
           :data-glide-dir="`=${index}`">
          <img :src="image.small" :alt="`Loan image thumbnail ${index}`">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import Glide, { Autoplay, Controls, Images, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
  import LoanImage from '~/modules/loans/entities/frontend/loan-image'
  import { default as clFactory } from '~/utils/cloudinary'
  import i18n from './locales'

  const cl = clFactory()

  export default {
    name: 'LoanDetailsGallery',
    i18n,
    props: {
      main: {
        type: LoanImage,
        required: true,
      },
      secondary: {
        type: Array,
        default: () => ([]),
      },
    },
    data () {
      return {}
    },
    computed: {
      images () {
        return [
          this.main,
          ...this.secondary,
        ]
      },
      renderThumbs () {
        return this.$device.isMedium
      },
    },
    methods: {
      getImageSrc (publicId) {
        return cl.url(publicId, {
          crop: 'fit',
          height: 600,
          width: 800,
        })
      },
    },
    mounted () {
      const glide = new Glide(this.$el, {
        dragThreshold: false,
        focusAt: 'center',
        gap: 0,
        perView: 1,
        perTouch: 1,
        throttle: 0,
        type: 'carousel',
      })

      glide.mount({ Autoplay, Controls, Images, Swipe })
    },
  }
</script>

<style src="@glidejs/glide/dist/css/glide.core.css"></style>
<style src="@glidejs/glide/dist/css/glide.theme.css"></style>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours";

  .gallery {
    .glide__track {
      position: relative;

      .glide__slides {
        margin: 0;
      }
      .glide__bullets {
        bottom: 2rem;
      }
      .glide__thumbs {
        align-items: center;
        background: rgba($colour-white, 0.3);
        display: flex;
        justify-content: center;

        a {
          display: inline-block;
          border: 10px solid transparent;

          &:hover {
            cursor: pointer;
          }

          &.glide__bullet--active {
            border-color: $colour-orange;
          }

          img {
            height: 2rem;
          }
        }
      }
    }
  }
</style>
